import firebase from '../../firebase/compat'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { db } from '../../firebase/config'
import { client } from '../../hooks/Client'
import { SavedIcon } from "../../StateManagment/SavedIcon";
import { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import ResearchMeta from "../../components/Research/ResearchMeta";
import MomentStatusChips from "../../components/Research/MomentStatusChips";
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import { useFirestoreOrderBy } from "../../firebase/useFirestore";
import PersonaResearchLink from "../../components/personas/PersonaResearchLink";
import DeleteModal from "../../components/common/DeleteModal";
import Modal from "../../components/common/Modal";
import Table from "../../components/common/table/Table.jsx";
import TableCell from "../../components/common/table/TableCell.jsx";
import ReadOnlyGuard from "../../components/common/ReadOnlyGuard";
import effectiveResearchIds, { isResearchForAll } from "../../helpers/measurementSignals/effectiveResearchIds";

const Research = ({adressNavigation, item, adressDocid}) => {
    // Context
        const [saved, setSaved] = useContext(SavedIcon)
    
    // State
    const [selectedResearch, setSelectedResearch] = useState('')
    const [showAddContainer, setShowAddContainer] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteDocid, setDeleteDocid] = useState('123')
    const [deleteName, setDeleteName] = useState('dit onderzoek')
    const [researchID, setResearchID] = useState('')

    // Hooks
    const history = useHistory()

    // Firestore
    const researchRaw = useFirestoreOrderBy('Research', 'Position', 'asc')
    const research = (researchRaw || []).filter((r) => !r.Deleted)
    // Zolang de onderzoeken onderweg zijn is "geen onderzoeken gekoppeld" een
    // onware bewering — dan kan een onderzoek dat voor alle huishoudens geldt
    // er nog aankomen.
    // AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
    const researchLoaded = Array.isArray(researchRaw)

    const researchHandler = (e) => {

        const value = e.target.options[e.target.selectedIndex].value

        setSelectedResearch(value)

    }

    const addResearch = () => {

        console.log('adressDocid', adressDocid)

        db.collection('Adresses')
        .doc(adressDocid)
        .update({
            Research: firebase.firestore.FieldValue.arrayUnion(selectedResearch)
        })
        .then(() => {
            setSaved('flex')
            setShowAddContainer(!showAddContainer)
        })

    }

        // Delete modal 
        const deleteModalHandler = (e) => {
        const docid = e.currentTarget.dataset.docid
        const deleteName = e.currentTarget.dataset.deletename
        const id = e.currentTarget.dataset.id

        setDeleteDocid(docid)
        setDeleteName(deleteName)
        setResearchID(id)

        setDeleteModal(!deleteModal)
    }


    const deleteResearch = (e) => {

        db.collection('Adresses')
        .doc(deleteDocid)
        .update({
            Research: firebase.firestore.FieldValue.arrayRemove(researchID)
        })
        .then(() => {
            setSaved('flex')
        })

    }

    const getResearchTitle = (researchId) =>
        research?.find((researchItem) => researchItem.ID === researchId)?.Title || '';

    // Wie doet mee: wat op het huishouden zelf staat (`item.Research`, met de
    // hand gekoppeld) plus elk onderzoek dat via de schakelaar voor alle
    // huishoudens geldt. Eén regel, in `effectiveResearchIds`.
    // AI-CONTEXT: See docs/features/automatische-deelname-onderzoek.md
    const handLinked = item?.Research || [];
    const linkedResearch = effectiveResearchIds({ kind: 'adress', linkedIds: handLinked, researches: research });
    const researchDoc = (researchId) => research.find((researchItem) => researchItem.ID === researchId);

  return (
    <div style={{display: adressNavigation === 'research' ? 'block' : 'none'}}>
        <div className="table-container dashboard-container">
            <div className='table-container'>
                <ReadOnlyGuard edit="addresses.edit">
                    {(canEdit) => !researchLoaded ? (
                        <p className="adress-dashboard-empty">Laden…</p>
                    ) : (
                        <Table
                            columns={[
                                { key: 'research', label: 'ONDERZOEK' },
                                { key: 'moments', label: 'METINGEN', searchable: false },
                                { key: 'start', label: 'START ONDERZOEK', searchable: false },
                                { key: 'results', label: 'RESULTATEN', searchable: false },
                                { key: 'delete', label: 'VERWIJDER', searchable: false },
                            ]}
                            items={linkedResearch}
                            getItemKey={(researchId) => `${item?.ID}-${researchId}`}
                            renderRow={(researchId) => (
                                <>
                                    <TableCell>
                                        <ResearchMeta item={researchId}/>
                                        {isResearchForAll(researchDoc(researchId), 'adress') && (
                                            <span className="measurement-signal-pill">alle huishoudens</span>
                                        )}
                                    </TableCell>
                                    <TableCell>
                                        <MomentStatusChips entityId={item?.ID} researchId={researchId}/>
                                    </TableCell>
                                    <TableCell>
                                        <PersonaResearchLink researchID={researchId} personaID={item?.ID}/>
                                    </TableCell>
                                    <TableCell>
                                        <BarChartOutlinedIcon className="table-delete-icon" onClick={() => history.push(`/${client}/researchresultspersonas/${item?.ID}/${researchId}`)}/>
                                    </TableCell>
                                    <TableCell>
                                        {/* Alleen een handmatige koppeling is hier weg te halen; een
                                            onderzoek dat voor alle huishoudens geldt zet je uit op het
                                            onderzoek zelf. */}
                                        {canEdit && handLinked.includes(researchId) && (
                                            <DeleteOutlinedIcon className='table-delete-icon' data-item={researchId} data-id={researchId} data-docid={item?.docid} data-deletename={'dit onderzoek'} onClick={deleteModalHandler} />
                                        )}
                                    </TableCell>
                                </>
                            )}
                            searchAccessor={(researchId) => getResearchTitle(researchId)}
                            searchPlaceholder="Zoeken op onderzoek"
                            emptyMessage="Geen onderzoeken gekoppeld."
                            addRow={canEdit ? {
                                toolTipContent: 'Extra onderzoek koppelen',
                                onClick: () => setShowAddContainer(true),
                            } : undefined}
                        />
                    )}
                </ReadOnlyGuard>
                <Modal
                    modalOpen={showAddContainer}
                    setModalOpen={setShowAddContainer}
                    pageHeader={'Onderzoek koppelen'}
                    confirm={addResearch}
                    confirmLabel={'Toevoegen'}
                    content={
                        <ReadOnlyGuard edit="addresses.edit">
                            <p>Selecteer een onderzoek</p>
                            <select name="" id="" onChange={researchHandler}>
                                <option value="">-- Selecteer een onderzoek --</option>
                                {research && research.map(item => (
                                    <option key={item.ID} value={item.ID}>{item.Title}</option>
                                ))}
                            </select>
                        </ReadOnlyGuard>
                    }
                />
            </div>
            <DeleteModal deleteModal={deleteModal} setDeleteModal={setDeleteModal} deleteItem={deleteResearch} deleteName={deleteName} />
        </div>
    </div>
  )
}

export default Research
